module.exports = __webpack_public_path__ + "static/img/pf1.c5dfbeab.png";